import log from 'loglevel';
import { useAuth } from '../../hooks/useAuth';
import { NoPermissions } from '../NoPermissions';

const TAG = '[WITH_PERMISSIONS]';

type WithPermissionProps = {
  permissions: string[],
  children: JSX.Element,
};

export const WithPermission = ({
  permissions,
  children,
}: WithPermissionProps): JSX.Element => {
  const { hasPermissions } = useAuth();

  if (!hasPermissions(permissions)) {
    log.debug(TAG, 'UI restriction because there is no permission', permissions);

    return <NoPermissions />;
  }

  return children;
};
